var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,18 C20,20.209139 16.418278,22 12,22 C7.67990596,22 4.15960076,20.2878484 4.00527613,18.1466412 L4,18 L6,18 C6,19.1045695 8.6862915,20 12,20 C15.3137085,20 18,19.1045695 18,18 L20,18 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4 7 6 7 6 18 4 18"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18 7 20 7 20 18 18 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C16.418278,3 20,4.790861 20,7 C20,9.209139 16.418278,11 12,11 C7.581722,11 4,9.209139 4,7 C4,4.790861 7.581722,3 12,3 Z M12,5 C8.6862915,5 6,5.8954305 6,7 C6,8.1045695 8.6862915,9 12,9 C15.3137085,9 18,8.1045695 18,7 C18,5.8954305 15.3137085,5 12,5 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSource);
export default __webpack_public_path__ + "static/media/data-source.3dae6c8a92d0da5ddd1e3b721835a097.svg";
export { ForwardRef as ReactComponent };